import i18n from '@/i18n'
import type {Opcion} from '@/components/admin-catalogo/chips-field'
import type {TerminoFamilia} from '@/hooks/inci/catalogo/use-admin-catalogo'

/** Conjuntos cerrados (invariante 7 de §8a): un código inventado revienta `CondicionCodigo(clave)`
 * de core/condiciones.py. Van a mano porque el esquema generado los da solo como tipos. */

// `libre` queda fuera a propósito: no deriva nada, así que no puede anclar una fila del catálogo.
const CONDICIONES_CATALOGO = [
  'alturas',
  'confinados',
  'tension_electrica',
  'conduccion',
  'alimentos',
  'porte_armas',
  'cargas',
  'herramientas_equipos',
  'ruido',
  'polvo',
  'quimicos',
  'vibraciones',
  'radiaciones',
  'trabajo_caliente',
  'izaje',
  'excavaciones',
  'biologico',
] as const

// La designación con fila (la licencia SST); no es una condición del cargo.
const DESIGNACIONES_CATALOGO = ['designacion_responsable_sst'] as const

export const TIPOS_REQUISITO = [
  'curso',
  'examen',
  'valoracion',
  'documento',
  'epp',
  'induccion',
  'permiso_evento',
] as const

export const DESTINOS_REQUISITO = [
  'plan_capacitacion',
  'matriz_documental',
  'matriz_examenes',
  'entrega_epp',
  'induccion',
  'programa_inspecciones',
] as const

// Falla al compilar si el backend agrega o quita una familia y `contract-types.sh` regenera el esquema.
export const FAMILIAS_TERMINO: readonly TerminoFamilia[] = [
  'cargo',
  'condicion',
  'curso_documento',
  'forma_restriccion',
]

export function opcionesCondicion(): Opcion[] {
  return [...CONDICIONES_CATALOGO, ...DESIGNACIONES_CATALOGO].map((value) => ({
    value,
    label: i18n.t(`condicionCargo.codigo.${value}`, {defaultValue: i18n.t(`adminCatalogo.designacion.${value}`)}),
  }))
}
